import React from "react";
import clsx from "clsx";

function Button({ variant = "primary", onClick, className, children }) {
  const classes = clsx(
    "flex justify-center font-arial items-center text-lg leading-7 rounded-md py-2.5 px-8", // common classes
    variant === "primary" &&
      "font-bold bg-primary-blue hover:bg-primary-blue-hover text-white",
    className
  );

  return (
    <button onClick={onClick} className={classes}>
      {children}
    </button>
  );
}

export default Button;
